import React, { useContext, useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import UserContext from "../contexts/UserContext";

function Header({ onStart, logout }) {
    const { state } = useContext(UserContext);
    const { user } = state;
    const [dropdownOpen, setDropdownOpen] = useState(false);


    return (
        <nav className="navbar navbar-expand-xl navbar-light bg-white" id="navbar">
            <div className="container">
                <NavLink to="/" className="navbar-brand"><img style={{height:'56px',width:'100%'}} src="/assets/img/logo.jpg" alt="" /> </NavLink>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarMenu">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <NavLink to="/store-front" className="nav-link">Store</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/create" className="nav-link">Minting</NavLink>
                        </li>
                        {
                            !!user && <>  
                             {/* <li className="nav-item">
                                <NavLink to="/profile" className="nav-link">Profile</NavLink>
                            </li> */}
                                <li className="nav-item">
                                    <NavLink to="/my-nfts" className="nav-link">User Gallery</NavLink>
                                </li></>
                        }

                    </ul>
                    
                        <form className="form-inline navbar-forminline my-2 my-lg-0">
                        {
                        !user ?
                            <a role={"button"} onClick={onStart} className="sign-up btns">Start</a>
                            :
<a role={"button"} onClick={logout} className="sign-up btns">Log out</a>
                        }
                        </form>
                
                </div>
            </div>
        </nav>
    )
}

export default Header;
